import { useEffect, useState } from "react";
import {
  createThread,
  dmrcChatGptRes,
  getDmrcForecastLoadData,
  getDmrcLoadData,
} from "../../Rest_api/RestApi";
import userEvent from "@testing-library/user-event";
import { formatDateString } from "../Dashboard/Auction/Auction";
import FilterMenu from "../../components/FilterMenu";
import { DateRange, DateRangePicker } from "react-date-range";
import { formatDMY, PrimaryColor } from "../../common";
import {
  FormatChartData,
  FormatChartDataWithAverages,
} from "../../components/recharts/functions";
import { ReMixChart } from "../../components/recharts/ReMixCharts";
import { ChartType } from "../../models/chart_model";
import { ExchangeColors } from "../Dashboard/Exchange3/FormatData";
import DmrcLoad, { DmrcForecastedLoad } from "../../models/dmrc";
import Loading from "../../components/Loading";
import ChatComponent from "../../components/chat/Chat";
import { render } from "@testing-library/react";
import { renderQuarterTick } from "../../components/recharts/components";
import "./dmrc.css";
import { SearchBox } from "../../components/Search";
import {
  MONTHS,
  SLOT_OPTIONS,
} from "./Data";
import { FilterTab } from "../../components/Filters";
import DmrcForecastChart from "./Forecast";
import TrendAnalysis from "./TrendAnalysis";
import { format } from "path";
const getWeekday = (dateString: string): string => {
  const date = new Date(dateString);
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return weekdays[date.getDay()];
};
const tabs = ["Trend", "Forecast"];
const getYear = (dateString: string): number => {
  return parseInt(dateString.substring(0, 4), 10); // Extracts the first 4 characters and converts to a number
};
const getMonth = (dateString: string): string => {
  const monthIndex = parseInt(dateString.substring(5, 7), 10) - 1; // Extracts the month part, converts to a number, and adjusts for 0-based index

  // Array of full month names
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return monthNames[monthIndex]; // Returns the month name
};
export default function Dmrc() {
  const [snapshots, setSnapshots] = useState<DmrcForecastedLoad[]>([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gptLoading, setGptLoading] = useState(false);
  const [thread_id, setThreadId] = useState("");
  const [selectedSlots, setSelectedSlots] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [selectedStations, setSelectedStations] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [dates, setDate] = useState([
    {
      startDate: new Date("2024-01-01"),
      endDate: new Date("2024-03-31"),
      key: "selection",
    },
  ]);

  const [forecastDates, setForecastDates] = useState([
    {
      startDate: new Date("2024-04-01"),
      endDate: new Date("2024-04-30"),
      key: "selection",
    },
  ]);
  const [dateRange, setDateRange] = useState(dates[0]);
  const [forecastDateRange, setForecastDateRange] = useState(forecastDates[0]);
  const [chatMessages, setChatMessages] = useState<
    { sender: String; content: String }[]
  >([]);
  const predefinedQueries = [
    "Which substation had the highest load ?",
    "What was the average load?",
    "What was the contribution of substations to the total load ?",
    "List the slots with peak load",
    "Which are the top five substations with the lowest load ?",
    "What was the contribution of substations to the peak ?",
  ];
  
  const [awaitingDateRange, setAwaitingDateRange] = useState(false); // Tracks if waiting for date range input
  const [currentQuestion, setCurrentQuestion] = useState<string | null>(null); // Stores the current question from the suggestion
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [aprilSnapshots, setAprilSnapshots] = useState<DmrcForecastedLoad[]>([]);
  useEffect(() => {
    createThread().then((response) => {
      setThreadId(response.thread_token);
    });
  }, []);

  useEffect(() => {
    _handleFetchingData(
      formatDateString(dates[0].startDate),
      formatDateString(dates[0].endDate)
    );
  }, [dates]);


  useEffect(() => {
    _handleAprilFetchingData(
      formatDateString(forecastDates[0].startDate),
      formatDateString(forecastDates[0].endDate)
    );
  }, [forecastDates]);

  const _handleAprilFetchingData = async (start_date: string, end_date: string) => {
    setLoading(true);
    const response = await getDmrcForecastLoadData({
      startDate: start_date,
      endDate:  end_date,
    });

    setAprilSnapshots(
      response.map((item) => {
        const forecast = item.demand_forecast_mw!;
        return {
          station__name: item.station__name,
          date: item.date,
          time_slot: item.time_slot,
          demand_mw: item.demand_mw,
          demand_forecast_mw: forecast,
          // upper_forecast: forecast,
          demand_mwh: item.demand_mw / 4,
          // deviation_mw: forecast - item.demand_mw,
          // deviation_mwh: (forecast - item.demand_mw ) / 4,
          demand_forecast_mwh: forecast / 4,
          date__week: getWeekday(item.date),
          date__month: getMonth(item.date) as any,
          date__year: getYear(item.date),
          date__day: item.date__day,
        };
      })
    );
    setLoading(false);
  };
  const _handleFetchingData = async (start_date: string, end_date: string) => {
    setLoading(true);
    const response = await getDmrcForecastLoadData({
      startDate: start_date,
      endDate: end_date,
    });

    setSnapshots(
      response.map((item) => {
        const forecast = item.demand_forecast_mw!;
        return {
          station__name: item.station__name,
          date: item.date,
          time_slot: item.time_slot,
          demand_mw: item.demand_mw,
          demand_forecast_mw: forecast,
          // upper_forecast: forecast,
          demand_mwh: item.demand_mw / 4,
          // deviation_mw: item.demand_mw - forecast,
          // deviation_mwh: (item.demand_mw - forecast) / 4,
          // demand_forecast_mwh: forecast / 4,
          date__week: getWeekday(item.date),
          date__month: getMonth(item.date) as any,
          date__year: getYear(item.date),
          date__day: item.date__day,
        };
      })
    );
    setLoading(false);
  };

  

  const _handleGptResponse = async (query: string) => {
    setChatMessages([...chatMessages, { sender: "user", content: query }]);

    // If awaiting a date range and received the date range:
    if (awaitingDateRange) {
      const mergedQuery = `${currentQuestion} for the date range ${query}`;
      setAwaitingDateRange(false); // Reset state
      setCurrentQuestion(null); // Clear the current question

      setGptLoading(true);
      const response = await dmrcChatGptRes({
        query: mergedQuery,
        thread_token: thread_id,
      });
      setChatMessages([
        ...chatMessages,
        { sender: "user", content: query },
        { sender: "ai", content: response.content },
      ]);
      setGptLoading(false);
    } else {
      // Check if the query matches one of the predefined suggestions

      if (predefinedQueries.includes(query)) {
        // Ask for the date range
        setAwaitingDateRange(true);
        setCurrentQuestion(query);
        setChatMessages([
          ...chatMessages,
          { sender: "user", content: query },
          { sender: "ai", content: "Could you please specify the date range?" },
        ]);
      } else {
        // Regular query handling
        setGptLoading(true);
        const response = await dmrcChatGptRes({
          query: query,
          thread_token: thread_id,
        });
        setChatMessages([
          ...chatMessages,
          { sender: "user", content: query },
          { sender: "ai", content: response.content },
        ]);
        setGptLoading(false);
      }
    }
  };



  const DatePicker = () => {
    return (
      <>
        &nbsp;
        <button
          onClick={() => {
            setVisible(!visible);
          }}
          className="date-range-button"
        >
          <span className="date-range">
            {formatDMY(formatDateString(dateRange.startDate))}
          </span>{" "}
          to{" "}
          <span className="date-range">
            {formatDMY(formatDateString(dateRange.endDate))}
          </span>
        </button>
        {visible && (
          <div
            className="pop-up-date"
            onClick={(e) => {
              setVisible(false);
            }}
          >
            <div
              className="date-selection-wrapper"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <DateRangePicker
                onChange={(item) => setDateRange(item.selection as any)}
                showPreview={true}
                dragSelectionEnabled={false}
                minDate={new Date("2022-01-01")}
                maxDate={new Date("2025-12-31")}
                moveRangeOnFirstSelection={false}
                rangeColors={[PrimaryColor, PrimaryColor, PrimaryColor]}
                months={2}
                ranges={[dateRange]}
                direction="horizontal"
              />
              <button
                onClick={() => {
                  setDate([
                    {
                      startDate: new Date(
                        dateRange.startDate
                          .toLocaleDateString("en-GB")
                          .split("/")
                          .reverse()
                          .join("-")
                      ),
                      endDate: new Date(
                        dateRange.endDate
                          .toLocaleDateString("en-GB")
                          .split("/")
                          .reverse()
                          .join("-")
                      ),
                      key: "selection",
                    },
                  ]);
                  setVisible(false);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}{" "}
      </>
    );
  };

  const ForecastDatePicker = () => {
    return (
      <>
        &nbsp;
        <button
          onClick={() => {
            setVisible(!visible);
          }}
          className="date-range-button"
        >
          <span className="date-range">
            {formatDMY(formatDateString(forecastDateRange.startDate))}
          </span>{" "}
          to{" "}
          <span className="date-range">
            {formatDMY(formatDateString(forecastDateRange.endDate))}
          </span>
        </button>
        {visible && (
          <div
            className="pop-up-date"
            onClick={(e) => {
              setVisible(false);
            }}
          >
            <div
              className="date-selection-wrapper"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <DateRangePicker
                onChange={(item) => setForecastDateRange(item.selection as any)}
                showPreview={true}
                dragSelectionEnabled={false}
                minDate={new Date("2022-01-01")}
                maxDate={new Date("2025-12-31")}
                moveRangeOnFirstSelection={false}
                rangeColors={[PrimaryColor, PrimaryColor, PrimaryColor]}
                months={2}
                ranges={[forecastDateRange]}
                direction="horizontal"
              />
              <button
                onClick={() => {
                  setForecastDates([
                    {
                      startDate: new Date(
                        forecastDateRange.startDate
                          .toLocaleDateString("en-GB")
                          .split("/")
                          .reverse()
                          .join("-")
                      ),
                      endDate: new Date(
                        forecastDateRange.endDate
                          .toLocaleDateString("en-GB")
                          .split("/")
                          .reverse()
                          .join("-")
                      ),
                      key: "selection",
                    },
                  ]);
                  setVisible(false);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}{" "}
      </>
    );
  };

  return (
    <>
      <div className="h-full">
        {loading && <Loading />}
        <div className="header">
          <h1>Load Curve</h1>
          <div></div>
          <FilterTab
            options={tabs}
            selected={[selectedTab]}
            onClick={(option, index) => {
              setSelectedTab(option);
            }}
          />
          <div className="date-selection">
            <div className="time-slot-search">
              <SearchBox
                options={Array.from(
                  new Set(snapshots.map((item) => item.station__name)),
                ).map((name) => ({ value: name, label: name }))}
                isMany={true}
                placeholder="Select Stations..."
                selectedOptions={selectedStations as any}
                onChange={(selected: any) => {
                  setSelectedStations(selected);
                }}
              />
            </div>

            <div className="time-slot-search">
              <SearchBox
                options={SLOT_OPTIONS}
                isMany={true}
                placeholder="Select Slots..."
                selectedOptions={selectedSlots as any}
                onChange={(selected: any) => {
                  setSelectedSlots(selected);
                }}
              />
            </div>

            {selectedTab === tabs[0] && <DatePicker />}
            {selectedTab !== tabs[0] && <ForecastDatePicker />}
          </div>
        </div>
        <div className="h-full tabContent">
          {" "}
          {selectedTab === tabs[0] && (
            <TrendAnalysis
              snapshots={snapshots}
              selectedSlots={selectedSlots}
              selectedStations={selectedStations}
            />
          )}
          {selectedTab === tabs[1] && (
            <DmrcForecastChart
              snapshots={aprilSnapshots}
              selectedSlots={selectedSlots}
              selectedStations={selectedStations}
            />
          )}
        </div>
      </div>
      <ChatComponent
        onInput={(message) => {
          _handleGptResponse(message);
        }}
        onClear={() => {
          setChatMessages([]);
          setGptLoading(false);
          setAwaitingDateRange(false);
          setCurrentQuestion(null);
        }}
        defaultMessages={predefinedQueries}
        messages={chatMessages as any}
        isLoading={gptLoading}
      />
    </>
  );
}
